import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';

/* actions */
import * as Actions from '../../redux/actions';


class GetExpertsPage extends baseRequest{

    constructor() {
        super();
        this.dispatch = null;
        this.response = null;
        this.name     = 'General Declaration Request';
        this.Config   = new AppConfig();
    }

    execute(dispatch) {
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.getExpertsPage);
    }

    //Parse successful response
    onSuccess() {
        let data = this.response.data;
        this.updateState(data);
    }

    //Dispatch actions to update redux state
    updateState(data) {
        this.dispatch(Actions.setExpertsPage(data));
    }
}


export default GetExpertsPage;